import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { SelectedFiltersWrapper } from '../components/pill/pill.styles'
import {
    DesktopDisplayContainer,
    MobileDisplayContainer,
    StyledCTAContainer,
} from '../components/search-filters-cta/search-filter-cta.styles'
import { FILTER_AND_SORT_BUTTON_WIDTH, PILL_HEIGHT } from '../constants/styling'

export const SkeletonPills = () => {
    return (
        <StyledCTAContainer>
            <SelectedFiltersWrapper>
                <MobileDisplayContainer>
                    <Skeleton
                        style={{
                            width: PILL_HEIGHT,
                            height: PILL_HEIGHT,
                            borderRadius: PILL_HEIGHT,
                        }}
                    />
                </MobileDisplayContainer>
                {[...Array(5)].map((_, i) => (
                    <Skeleton
                        key={i}
                        style={{
                            width: FILTER_AND_SORT_BUTTON_WIDTH,
                            height: PILL_HEIGHT,
                            borderRadius: PILL_HEIGHT,
                        }}
                    />
                ))}
            </SelectedFiltersWrapper>
            <DesktopDisplayContainer>
                <Skeleton
                    style={{
                        width: FILTER_AND_SORT_BUTTON_WIDTH,
                        height: PILL_HEIGHT,
                        borderRadius: PILL_HEIGHT,
                    }}
                />
            </DesktopDisplayContainer>
        </StyledCTAContainer>
    )
}
